class CartDrawer extends MenuDrawer {
  constructor() {
    super();

    this.bindOnMenuDrawerOpen();
    //hide gamification in other countries than germany
    // this.gamificationBasedOnCountry();

  }

  connectedCallback () {
    window.addEventListener('load', (event) => {
      document.querySelector('cart-drawer').OnMenuDrawerOpen();
    });
  }

  bindOnMenuDrawerOpen() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', () => {
        if (this.querySelector('#drawer-cart-items').childElementCount == 0) {
          this.OnMenuDrawerOpen.bind(this);
        }
    }))
  }

  // gamificationBasedOnCountry(){
  //   let location_url = window.location.href;
  //   if(location_url.includes('uk.')
  //   || location_url.includes('eu.')
  //   || location_url.includes('ch.') || (localStorage.getItem('userCountryCode')
  //   && localStorage.getItem('userCountryCode') != 'DE')){
  //     let gamificationWrapper = this.querySelector('#cart-drawer-gamification'),
  //         tempThis = this;

  //       gamificationWrapper.style.display = 'none';

  //     this.changeDrawerHeightsBasedOnGamification();
  //     window.addEventListener('resize', function(){
  //       tempThis.changeDrawerHeightsBasedOnGamification();
  //     });
  //   }
  // }

  changeDrawerHeightsBasedOnGamification(){
    let  headerWrapper = this.querySelector('.cart-drawer__header'),
         navigationWrapper = this.querySelector('.cart-drawer__navigation');

    headerWrapper.style.height = '64px';
    headerWrapper.style.borderBottom = '1px solid #e0e0e0';
    navigationWrapper.style.height = 'calc(100vh - 64px)';
    navigationWrapper.style.maxHeight = 'calc(100% - 64px)';

    if(window.innerWidth <= 750){
      headerWrapper.style.height = '54px';
      navigationWrapper.style.height = 'calc(100vh - 54px)';
      navigationWrapper.style.maxHeight = 'calc(100% - 54px)';
    }
  }

  OnMenuDrawerOpen () {
    const sectionsURL =
      routes.rootUrl +
      "/?sections=" +
      this.getSectionsToRender()
        .map((section) => section.id)
        .join(",");
    fetch(sectionsURL)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }

        var sections = { sections: response };
        this.renderContents(sections);
        console.log(sections);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        console.log('request done successfully');
      });
  }

  renderContents(parsedState, forceDrawerOpen = false) {
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      crossSellITemsListeners();
      this.handleCrossSellGrapping();
      // if (this.header) this.header.reveal();
      // this.open();
      if (forceDrawerOpen) {
        this.querySelector('summary').click();
      }
  }

  getSectionsToRender() {
    return [
      {
        id: 'drawer-cart-items'
      },
      {
        id: 'drawer-cart-footer'
      },
      {
        id: 'cart-icon-bubble'
      },
      {
        id: 'cart-drawer-gamification'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
  handleCrossSellGrapping(){
    const crossSellSlider = document.querySelector('.cross-sell-slider');
    let isDown = false;
    let startX;
    let scrollLeft;

    if(crossSellSlider){
      crossSellSlider.addEventListener('mousedown', (e)=>{
        isDown = true;
        crossSellSlider.classList.add('active');
        startX = e.pageX - crossSellSlider.offsetLeft;
        scrollLeft = crossSellSlider.scrollLeft;
      })
      crossSellSlider.addEventListener('mouseup', ()=>{
        isDown = false;
        crossSellSlider.classList.remove('active');
      })
      crossSellSlider.addEventListener('mouseleave', ()=>{
        isDown = false;
        crossSellSlider.classList.remove('active');
      })
      crossSellSlider.addEventListener('mousemove', (e)=>{
        if(!isDown) return;
        e.preventDefault();
        const x = e.pageX - crossSellSlider.offsetLeft;
        const walk = (x - startX);
        crossSellSlider.scrollLeft = scrollLeft - walk;
      })
    }
  }
}

customElements.define('cart-drawer', CartDrawer);